import React from 'react';

// Standardized pass reasons — aligned with the Phase-1 investment scorecard + practice.
export const PASS_REASONS = [
  { id: 'ebitda_small', label: 'EBITDA too small' },
  { id: 'margin_low', label: 'Margin too low (<15%)' },
  { id: 'too_big', label: 'Too big / above corridor' },
  { id: 'valuation_high', label: 'Valuation too high' },
  { id: 'sector_mismatch', label: 'Sector mismatch / no infra angle' },
  { id: 'outside_germany', label: 'Outside Germany' },
  { id: 'no_majority', label: 'No majority available' },
  { id: 'customer_concentration', label: 'Customer concentration' },
  { id: 'owner_dependency', label: 'Owner dependency' },
  { id: 'no_sell_motivation', label: 'No real sell motivation' },
  { id: 'successor_in_place', label: 'Successor already in place' },
  { id: 'no_recurring_revenue', label: 'Project business / no recurring revenue' },
  { id: 'declining_financials', label: 'Declining financials / losses' },
  { id: 'history_too_short', label: 'Profitable history too short' },
  { id: 'red_flags', label: 'Red flags (legal / tech / compliance)' },
  { id: 'exit_unclear', label: 'Exit unclear' },
  { id: 'broad_auction', label: 'Broad auction / no angle' },
  { id: 'no_response', label: 'No response to outreach' },
  { id: 'asset_heavy', label: 'Asset-heavy / high capex' },
];

export const passReasonText = (tags) =>
  PASS_REASONS.filter(r => tags.includes(r.id)).map(r => r.label).join('; ');

export function PassReasonPicker({ selected, onToggle }) {
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="pass-reason-chips">
      {PASS_REASONS.map(r => {
        const on = selected.includes(r.id);
        return (
          <button key={r.id} type="button" onClick={() => onToggle(r.id)}
            data-testid={`pass-reason-chip-${r.id}`}
            className={`text-[10px] px-2 py-1 rounded-sm border transition-colors ${on
              ? 'border-red-500/50 bg-red-500/15 text-red-300'
              : 'border-border bg-secondary/40 text-muted-foreground hover:text-foreground hover:border-red-500/30'}`}>
            {r.label}
          </button>
        );
      })}
    </div>
  );
}
